import withStyles from '@mui/styles/withStyles';

const styles = theme => ({
  "@global": {
    /**
     * Disable the focus outline, which is default on some browsers like
     * chrome when focusing elements
     */
    "*:focus": {
      outline: 0
    },
    html: {
      scrollBehavior: "smooth"
    },
    body: {
      backgroundColor: theme.palette.common.paper,
      fontFeatureSettings: '"ss01", "ss02"'
    },
    ".text-white": {
      color: theme.palette.common.white
    },
    ".text-ink": {
      color: theme.palette.common.ink
    },
    ".text-soft": {
      color: theme.palette.common.inkSoft
    },
    ".eyebrow": {
      fontFamily: "'Inter', sans-serif",
      fontWeight: 600,
      fontSize: "0.72rem",
      letterSpacing: "0.14em",
      textTransform: "uppercase",
      color: theme.palette.secondary.main
    },
    ".hairline": {
      border: "none",
      borderTop: `1px solid ${theme.palette.common.line}`,
      margin: 0
    },
    ".listItemLeftPadding": {
      paddingTop: `${theme.spacing(1.75)} !important`,
      paddingBottom: `${theme.spacing(1.75)} !important`,
      paddingLeft: `${theme.spacing(4)} !important`,
      [theme.breakpoints.down('md')]: {
        paddingLeft: `${theme.spacing(4)} !important`
      },
      "@media (max-width:  420px)": {
        paddingLeft: `${theme.spacing(1)} !important`
      }
    },
    ".container": {
      width: "100%",
      paddingRight: theme.spacing(4),
      paddingLeft: theme.spacing(4),
      marginRight: "auto",
      marginLeft: "auto",
      [theme.breakpoints.up("sm")]: {
        maxWidth: 560
      },
      [theme.breakpoints.up("md")]: {
        maxWidth: 760
      },
      [theme.breakpoints.up("lg")]: {
        maxWidth: 1080
      }
    },
    ".row": {
      display: "flex",
      flexWrap: "wrap",
      marginRight: -theme.spacing(2),
      marginLeft: -theme.spacing(2)
    },
    ".container-fluid": {
      width: "100%",
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      marginRight: "auto",
      marginLeft: "auto",
      maxWidth: 1180
    },
    ".lg-mg-top": {
      marginTop: `${theme.spacing(16)} !important`,
      [theme.breakpoints.down('lg')]: {
        marginTop: `${theme.spacing(14)} !important`
      },
      [theme.breakpoints.down('md')]: {
        marginTop: `${theme.spacing(12)} !important`
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: `${theme.spacing(10)} !important`
      }
    },
    ".lg-mg-bottom": {
      marginBottom: `${theme.spacing(10)} !important`,
      [theme.breakpoints.down('lg')]: {
        marginBottom: `${theme.spacing(9)} !important`
      },
      [theme.breakpoints.down('md')]: {
        marginBottom: `${theme.spacing(8)} !important`
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: `${theme.spacing(6)} !important`
      }
    },
    ".lg-p-top": {
      paddingTop: `${theme.spacing(14)} !important`,
      [theme.breakpoints.down('lg')]: {
        paddingTop: `${theme.spacing(12)} !important`
      },
      [theme.breakpoints.down('md')]: {
        paddingTop: `${theme.spacing(10)} !important`
      },
      [theme.breakpoints.down('sm')]: {
        paddingTop: `${theme.spacing(8)} !important`
      }
    }
  }
});

function globalStyles() {
  return null;
}

export default withStyles(styles, { withTheme: true })(globalStyles);
